import { useRef, useState } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { MoreHorizontal } from 'lucide-react';
import { ActionMenu, Button, type ActionMenuItem } from '@/shared/components';
import type { PropertyGroupResponse } from '@/shared/api';
import { ObjectStructureControl } from './ObjectStructureControl';

/**
 * Seltene Objekt-Aktionen im Kopf. Die Struktur-Wege stehen hinter einem Eintrag, der ihre
 * Sperrgründe zeigt — abgeblendete destruktive Menüeinträge lesen sich wie ein Fehler.
 */
export function ObjectActionsMenu({ group }: { group: PropertyGroupResponse }) {
  const navigate = useNavigate();
  const [structureOpen, setStructureOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const items: ActionMenuItem[] = [
    {
      label: 'Apartment hinzufügen',
      icon: 'Plus',
      onClick: () => void navigate({ to: '/properties/new', search: { objectId: group.id } }),
    },
    { separator: true },
    { label: 'Objektstruktur ändern …', icon: 'Archive', onClick: () => setStructureOpen(true) },
  ];

  return (
    <>
      <ActionMenu
        trigger={
          <Button
            ref={triggerRef}
            variant="ghost"
            className="border-line bg-card min-h-11 min-w-11 shrink-0 border px-3 sm:px-[17px]"
            leftIcon={<MoreHorizontal size={16} strokeWidth={2} aria-hidden />}
          >
            {/* Auf dem Telefon steht nur das Symbol neben dem Titel; der Name bleibt vorlesbar. */}
            <span className="sr-only sm:not-sr-only">Aktionen</span>
          </Button>
        }
        items={items}
      />
      <ObjectStructureControl
        group={group}
        open={structureOpen}
        onOpenChange={setStructureOpen}
        returnFocusTo={triggerRef}
      />
    </>
  );
}
